<template>
    <div>
        <headerNav title="账号管理"/>
        <van-cell-group>
            <van-cell title="修改个人信息"  is-link />
            <van-cell title="修改登录密码"  is-link />
            <van-cell title="修改绑定手机"  is-link />
            <van-cell title="关联账号"  is-link />
            <van-cell title="切换账号"  is-link to="/login" />
        </van-cell-group>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
